module.exports = __webpack_public_path__ + "static/media/404.d6d1768c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/404.png
// module id = 1655
// module chunks = 0